export default "__VITE_ASSET__Bfniixz7__"